export { default as ComingSoon } from './coming-soon';
